import React from 'react'
import { FormattedMessage } from 'react-intl'
import confetti from 'canvas-confetti'
import { Button, Grid, Fade, Typography, Paper } from '@material-ui/core'
import { useStyles } from './Styles'
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded'
import { Link, NavLink } from 'react-router-dom'
import { NamedRoutes } from '../../../../routes'
import { formatRoute } from 'react-router-named-routes'

const InvoiceCreateStep7 = ({ invoiceSubmissionUUID, resetInvoice }) => {
  const classes = useStyles()

  React.useEffect(() => {
      let myCanvas = document.createElement('canvas')
      myCanvas.setAttribute('id', 'confetti-wrapper')
      document.body.appendChild(myCanvas)
      let myConfetti = confetti.create(myCanvas, {
        resize: true,
        useWorker: true
      })
      myConfetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 }
      })

      setTimeout(() => {
        confetti.reset()
        document.body.removeChild(myCanvas)
      }, 5000)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <Fade in={true}>
      <Paper elevation={4} className={classes.invoiceStepWrapper}>
        <Grid item xs={12} sm={9} md={7} lg={4}>
          <div className={classes.confirmationWrapper}>
            <div className={classes.successHeader}>
              <CheckCircleRoundedIcon/>
              <Typography variant={'h3'} component={'h3'}><FormattedMessage id='successHeader'/></Typography>
            </div>

            <Typography className={classes.successMessage} variant={'h6'}>
              <FormattedMessage id='successMessage'/>
            </Typography>

            <div className={classes.submissionIdWrapper}>
              <span><FormattedMessage id='submissionId.is'/></span>
              <span className={classes.submissionId}><NavLink
                to={formatRoute(NamedRoutes.submission, { id: invoiceSubmissionUUID })}>{invoiceSubmissionUUID}</NavLink>
                </span>
            </div>

            <Typography className={classes.successMessage} variant={'body1'} paragraph>
              <FormattedMessage id='successHint'/>
            </Typography>

            <Typography className={classes.successMessage} variant={'body1'} paragraph>
              <FormattedMessage id='successHintLinks'
                                values={{
                                  creatLink: chunks => <Button size={'small'} variant={'text'} color={'primary'}
                                                               component={Link} to={NamedRoutes.newInvoice}
                                                               onClick={resetInvoice}
                                                               className={classes.linkBtn} disableRipple
                                                               disableElevation>
                                    {chunks}
                                  </Button>,
                                  invoicesLink: chunks => <Button size={'small'} variant={'text'} color={'primary'}
                                                                  component={Link} to={NamedRoutes.invoices}
                                                                  className={classes.linkBtn} disableRipple
                                                                  disableElevation>
                                    {chunks}
                                  </Button>
                                }}/>
            </Typography>
          </div>
        </Grid>
      </Paper>
    </Fade>
  )
}

export default InvoiceCreateStep7
